import { render, staticRenderFns } from "./Zones.vue?vue&type=template&id=2cf5c58a&scoped=true"
import script from "./Zones.vue?vue&type=script&lang=js"
export * from "./Zones.vue?vue&type=script&lang=js"
import style0 from "./Zones.vue?vue&type=style&index=0&id=2cf5c58a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cf5c58a",
  null
  
)

export default component.exports